export const muiLocaleMap: Record<string, string> = {
  ru: 'ruRU',
};
